export default __webpack_public_path__ + "static/media/wallet_connect.cc8508f3.svg";